<template>
    <div style="width: 608px;">
        <FormModel
                :action="submit" :labelCol="{span:4}" :model="config.share"
                :rules="rules" :wrapperCol="{span: 20}">
            <a-form-model-item label="封面图片" prop="cover" required style="margin-bottom: 13px;">
                <div style="width:120px; float:left;">
                    <ImageUpload :height="100" :width="100" v-model="config.share.cover"/>
                </div>
                <div style="line-height:22px; padding-top:30px; float:left;">
                    <div>1. 仅支持 JPG 或 PNG 格式</div>
                    <div>2. 建议上传尺寸 300px * 300px</div>
                </div>
            </a-form-model-item>
            <a-form-model-item label="分享标题" prop="title">
                <a-input placeholder="请输入分享标题" v-model="config.share.title"/>
            </a-form-model-item>
            <a-form-model-item label="分享描述" prop="desc">
                <a-input placeholder="请输入分享标题" rows="3" type="textarea" v-model="config.share.desc"/>
            </a-form-model-item>
        </FormModel>
        <div style="margin: 45px 0 0 90px; background: #eee; padding: 20px;">
            <div v-if="album.id" style="margin-bottom:20px;">
                <code>{{ liveUrl }}</code>
                <a-button icon="copy" style="margin-left: 12px;"
                          v-clipboard:copy="liveUrl"
                          v-clipboard:error="()=>$message.error('复制失败')"
                          v-clipboard:success="()=>$message.success('复制成功')">
                    复制
                </a-button>
                <a-button @click="jump" icon="link" type="link">打开</a-button>
            </div>
            <a-row v-if="album.material">
                <a-col span="13">
                    <ResourceImg :height="210" :id="album.material.qr_code" :width="210"
                                 style="border:1px #e8e8e8 solid; padding: 15px; border-radius: 15px;background: #fafafa;"/>
                </a-col>
                <a-col span="10" style="padding-top: 5px;">
                    <a-radio-group :options="sizeOptions" style="line-height: 25px;" v-model="QRCodeSize"/>
                    <a-button :loading="saving" @click="save" block style="margin-top: 15px;" type="default">下载保存到本地
                    </a-button>
                    <p style="margin: 10px 0 0 0;width: 100%; text-align: center;"><b>扫描二维码即可进入直播页面</b></p>
                </a-col>
            </a-row>
        </div>
    </div>
</template>

<script>
   import api from "../../../../utils/api";
   import func from "../../../../utils/func";
   import cache from "../../../../utils/cache";
   import FormModel from "../../../../comps/FormModel";
   import ImageUpload from "../../../../comps/ImageUpload";
   import ResourceImg from "../../../../comps/ResourceImg";

   export default {
      name: "Share",
      props: {album: Object},
      components: {ResourceImg, ImageUpload, FormModel},
      data() {
         return {
            config: {
               share: {title: "", desc: "", cover: ""},
            },
            rules: {
               title: {required: true},
               cover: {required: true},
               desc: {required: true},
            },
            saving: false,
            QRCodeSize: 1,
            sizeOptions: [
               {value: 1, label: "迷你【 200px * 200px 】"},
               {value: 2, label: "小号【 400px * 400px 】"},
               {value: 3, label: "中等【 800px * 800px 】"},
               {value: 4, label: "大号【 1600px * 1600px 】"},
               {value: 5, label: "特大【 3200px * 3200px 】"},
            ]
         }
      },
      computed: {
         liveUrl() {
            return api.v1.album.preview(this.album.id);
         },
      },
      mounted() {
         this.config = func.copyObject(this.album.config);
      },
      methods: {
         jump() {
            window.open(this.liveUrl, "_blank");
         },
         save() {
            this.saving = true;
            let width = Math.pow(2, this.QRCodeSize) * 100;
            api.v1.resource
               .create({
                  ttl: 1, public: true, suffix: "png",
                  content: func.imageUrl(this.album.material.qr_code, {resize: `m_8,w_${width},h_${width}`}, true),
               })
               .then(res => {
                  let sizeName = this.sizeOptions[this.QRCodeSize - 1].label;
                  window.open(api.v1.resource.download(res.id, `${sizeName}_${this.album.info.name}.png`))
               })
               .finally(() => this.saving = false);
         },
         submit() {
            return cache.v1.album.setConfig(this.album.id, this.config)
               .then(() => this.album.config = this.config);
         }
      }
   }
</script>

<style lang="less" scoped>
    code {
        padding: 7px 10px;
        border: 1px #ddd solid;
        border-radius: 4px;
        background: #fafafa;
    }
</style>